import { useEffect, useState } from "react";
import CustomSearch from "../SearchBox/SearchBox";
import { useTranslation } from "react-i18next";
import './HomePage.css'
import LeftArrow from '../../assets/leftArrow.svg';
import ThumbsUpIcon from '../../assets/thumbsUpIcon.png';
import ThumbDownIcon from '../../assets/thumbDownIcon.png';
import { Button, Input, Modal } from 'antd';
import '../../i18n';
import '../../local';
import { submitThumbsDwonApi, submitThumbsUpApi } from "../../api/api";
import { useNavigate } from 'react-router-dom';


function HomePage({ lang }: { lang: string }) {
  const navigate = useNavigate();
  useEffect(() => {
    if (lang) {
      lang = document.documentElement.lang;
    }
  }, [lang]);
  const { t } = useTranslation();
  const { TextArea } = Input;
  //modal
  const [open, setOpen] = useState(false);
  const [filteredList, setFilteredList] = useState<any>([]);
  const [showFeedbackList, setShowFeedbackList] = useState(false);
  const [btnDownClicked, setBtnDownClicked] = useState(false);
  const [btnUpClicked, setBtnUpClicked] = useState(false);
  const [serviceNamesEnFromFilteredList, setServiceNamesEnFromFilteredList] = useState([]);
  const [serviceNamesArFromFilteredList, setServiceNamesArFromFilteredList] = useState([]);
  const [selectedServiceId, setSelectedServiceId] = useState<any>(null)
  const [selectedService, setSelectedService] = useState(null);
  const [value, setValue] = useState('');

  // State to manage submit button disabled state
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);

  useEffect(() => {
    // Update the submit button state based on whether a service is selected or the "Tell us why" section has text
    setIsSubmitDisabled(!selectedService && value.trim() === '');
  }, [selectedService, value]);

  const showModal = () => {
    setOpen(true);
  };
  const handleCancel = () => {
    setOpen(false);
    setTimeout(() => {
      console.log('Navigating back');  // Log inside setTimeout before navigation
      navigate(-1);  // Navigate back
    }, 1000);
  };
  const resetModalState = () => {
    setBtnUpClicked(false);
    setBtnDownClicked(false);
    setShowFeedbackList(false);
    setValue('');
    setSelectedService(null);
  };

  const handleOk = async () => {
    !showFeedbackList ? setBtnUpClicked(true) : setBtnUpClicked(false);
    try {
      const submitThumbsUpFeedback = await submitThumbsUpApi(btnDownClicked, value, selectedServiceId);
      console.log("feedback status code", submitThumbsUpFeedback.STATUS_CODE);  // Log the API response
    } catch (error) {
      console.error("error", error);  // Log any errors
    }

    setOpen(false);
    resetModalState();
    console.log('State reset and about to navigate');  // Log right before navigation

    setTimeout(() => {
      console.log('Navigating back');  // Log inside setTimeout before navigation
      navigate(-1);  // Navigate back
    }, 1000);
  };

  const handleSubmit = async () => {
    setBtnDownClicked(true);
    try {
      const submitThumbsDownFeedback = await submitThumbsDwonApi();
      console.log("res", submitThumbsDownFeedback.FEEDBACK_SERVICES);
      const newFilteredList = submitThumbsDownFeedback.FEEDBACK_SERVICES.filter((item: any) => item.CATEGORY === '2');
      console.log(newFilteredList);

      // Update state with the new filtered list
      setFilteredList(newFilteredList);

      // Update service names list for EN and AR from the new filtered list
      const newServiceNamesEn = newFilteredList.map((item: any) => item.SERVICE_NAME_EN);
      const newServiceNamesAr = newFilteredList.map((item: any) => item.SERVICE_NAME_AR);
      setServiceNamesEnFromFilteredList(newServiceNamesEn);
      setServiceNamesArFromFilteredList(newServiceNamesAr);
    } catch (error) {
      console.error("error", error);
    }
    setOpen(true);
    setShowFeedbackList(true);
  };

  const handleServiceBtnClick = (serviceName: any) => {
    setSelectedService(serviceName);

    const serviceId = filteredList.find((service: any) => service.SERVICE_NAME_EN === serviceName || service.SERVICE_NAME_AR === serviceName)?.SERVICE_ID;
    setSelectedServiceId(serviceId); // Update the selected service ID state
    console.log(selectedServiceId);

  };

  return (
    <>
      <div className="home-page-continer">

        <div className="header-continer">
          <div className="content-wrapper">
            <img className="header-leftArrow" src={LeftArrow} onClick={showModal} />
            <div className="get-help-wrapper">
              <div className="header-get-help">{t('Get_help')}</div>
            </div>
          </div>
        </div>

        <Modal
          title=""
          open={open}
          onOk={handleOk}
          onCancel={handleCancel}
          closeIcon={true}
          closable={true}
          destroyOnHidden={true}
          okText=""
          className="modalCustomStyle"
          classNames={{ body: "ModalCustomBodyStyle" }}
          footer={() => (
            <>

              <div className="thumbsIcons">

                <div className="thumbsDownIcon" onClick={handleSubmit} style={btnDownClicked ? { border: '2px solid #008cff' } : { border: "none" }}><img src={ThumbDownIcon} /></div>
                <div className="thumbsUpIcon" onClick={handleOk} style={btnUpClicked ? { border: '2px solid #008cff' } : { border: "none" }}><img src={ThumbsUpIcon} /></div>
              </div>


              {showFeedbackList ? <div className="feedbackList">

                <div className="font-size-header">{t("What_did_you_not_like")}</div>

                <div className="serviceListContainer">
                  {lang && lang == 'en' ?

                    showFeedbackList && serviceNamesEnFromFilteredList.map((serviceName, index) => (
                      <div key={index} className="serviceListButtons" onClick={() => handleServiceBtnClick(serviceName)}
                        style={selectedService === serviceName ? { border: '2px solid #008cff' } : { border: '1px solid var(--neutrals-100, #d5d8df)', borderRadius: '16px' }}
                      >{serviceName}</div>
                    ))
                    :
                    showFeedbackList && serviceNamesArFromFilteredList.map((serviceName, index) => (
                      <div key={index} className="serviceListButtons" onClick={() => handleServiceBtnClick(serviceName)}
                        style={selectedService === serviceName ? { border: '2px solid #008cff' } : { border: '1px solid var(--neutrals-100, #d5d8df)', borderRadius: '16px' }}
                      >{serviceName}</div>
                    ))
                  }
                </div>

                <div>
                  <div className="modal-custom-headers">
                    <div className="font-size-header">{t("Why_not")}</div>
                  </div>
                  {/* <div style={{ margin: '24px 0' }} /> */}
                  <TextArea
                    value={value}

                    onChange={(e: any) => setValue(e.target.value)}
                    placeholder={t("Tell_us_why")}
                    autoSize={{ minRows: 3, maxRows: 7 }}
                  />
                </div>
                <div style={{ paddingTop: '25px', placeSelf: 'center' }}>
                  <Button shape="round" type="primary" size="middle" onClick={handleOk}  disabled={isSubmitDisabled}>{t("Submit")} </Button>
                </div>
              </div>
                : null}

            </>
          )}
        >
          <div className="modal-custom-headers">
            <div className="font-size-header">{t("Was_this_useful")}</div>
            <div className="modal-header-subText">{t("We_improve_with_real_feedback_like_yours")}</div>
          </div>
        </Modal>

        <div className="header-first-title">{t("What_are_you_having_an_issue_with")}</div>
        <div className="header-second-title">{t("Select_a_category_option_to_continue")}</div>
        <CustomSearch />
        {/* <footer className="footer-continer">

          <div className="footer-text">{t("Can’t_find_what_you’re_after")}</div>
          <div className="footer-btn">{t("Chat_with_us")}</div>
        </footer> */}
      </div>
    </>
  );
}

export default HomePage;
